export const filterActions = {
  FILTER_BY: "FILTER_BY",
};
